import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M17 8v8","key":"svg-2"}]]

/**
 * IconNumber14Small
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbnVtYmVyLTE0LXNtYWxsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik04IDhoMXY4IiAvPgogIDxwYXRoIGQ9Ik0xMyA4djNhMSAxIDAgMCAwIDEgMWgzIiAvPgogIDxwYXRoIGQ9Ik0xNyA4djgiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/number-14-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconNumber14Small = createReactComponent('outline', 'number-14-small', 'Number14Small', __iconNode);

export default IconNumber14Small;